const envTrue = (value, fallback = false) => {
  if (value === undefined || value === null || value === '') return fallback;
  return String(value).toLowerCase() === 'true';
};

export const PAYMENT_FEATURES = {
  ENABLE_GOOGLE_PLAY_BILLING: envTrue(process.env.REACT_APP_ENABLE_GOOGLE_PLAY_BILLING, true),
};

export const APP_FEATURES = {
  IS_ANDROID_BUILD: (typeof window !== 'undefined') && /android/i.test(navigator.userAgent || ''),
};
